import { sample, createStore } from 'effector';
export function once(unit) {
  var $canTrigger = createStore(true, {
    name: "$canTrigger",
    sid: "hqg5e0"
  });
  var trigger = sample({
    and: [{
      clock: unit,
      filter: $canTrigger
    }],
    or: {
      name: "trigger",
      sid: "-cvmmt0"
    }
  });
  $canTrigger.on(trigger, () => false);
  return sample({
    and: [{
      clock: trigger
    }],
    or: {
      sid: "-pw95tp"
    }
  });
}